import './TextArea-6ec228b2.css';

var classes = {"TextArea":"prc-Textarea-TextArea-13q4j"};

export { classes as default };
